import React, { useState } from 'react';
import logo from '../Image/logo.webp';
import login_line from '../Image/Login_line.png';
import { FaGoogle } from 'react-icons/fa';
import { NavLink, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile, signInWithPopup } from 'firebase/auth';
import { auth, GoogleAuthProvider } from '../firebase';
import { FaGithub } from 'react-icons/fa6';

function Signup({ setUser }) {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Update user's display name
      await updateProfile(user, { displayName: name });

      setUser(user);
      navigate("/home/projects");
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {
        setError('Email is already in use. Please use a different email.');
      } else {
        setError(error.message);
      }
    }
  };

  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        setUser(user);
        navigate("/home/projects");
        console.log(user);
      })
      .catch((error) => {
        setError(error.message);
      });
  };

  return (
    <>
      <div className="flex flex-col py-6 px-4">
        <img src={logo} className='w-52' alt="Logo" />
      </div>

      <div className="flex  flex-col gap-4 justify-between items-center w-full px-36">

        <div className="px-6 md:px-12 lg:px-24 xl:px-32 flex flex-col items-center">
          {error && <p className="text-red-500 mt-2">{error}</p>}
          <p className='text-white text-4xl lg:text-6xl font-semibold py-5 text-center'>Sign Up</p>
          <form className='flex flex-col gap-1 w-full max-w-md'>
            <p className='text-white mt-6 cursor-pointer'>Your Name</p>
            <input type="text" className='bg-gray-300 rounded-md pl-4 pr-2 lg:pr-28 py-3 border-none outline-none'
              value={name} onChange={(e) => setName(e.target.value)} required />

            <p className='text-white mt-6 cursor-pointer'>Email</p>
            <input type="text" className='bg-gray-300 rounded-md pl-4 pr-2 lg:pr-28 py-3 border-none outline-none'
              value={email} onChange={(e) => setEmail(e.target.value)} required />

            <p className='text-white mt-6 cursor-pointer'>Choose Password</p>
            <input type="password" className='bg-gray-300 rounded-md pl-4 pr-2 lg:pr-28 py-3 border-none outline-none'
              value={password} onChange={(e) => setPassword(e.target.value)} required />

            <button type="submit" onClick={onSubmit} className='bg-emerald-500 text-black rounded-md px-8 py-3 mt-4 hover:bg-emerald-700'>Submit</button>
          </form>

          <p className='text-white py-4 text-lg lg:text-2xl mt-4'>OR</p>
          <div className="bg-secondaryText rounded-md px-3 py-3 mt-5 cursor-pointer  hover:bg-black border border-gray-400">
            <button onClick={signInWithGoogle} className='text-white flex flex-row gap-2 lg:gap-6 pr-8 lg:pr-16'>
              <FaGoogle className='text-2xl text-yellow-500' /> Sign Up with Google
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;


